import css from 'styled-jsx/css';
import { common } from '../../../../theme/theme';

const style = css.global`
  .ebus-options-contents {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .ebus-options-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-bottom: 10px;
  }
  .ebus-options-subtitle {
    font-size: 14px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .ebus-options-input-container {
    width: 100%;
  }
  .ebus-options-input-row-container {
    display: flex;
    justify-content: space-between;
  }
  .ebus-options-input-container {
    display: flex;
    flex-direction: column;
  }
  .user-switch-wrapper {
    margin-bottom: 3px;
  }
  .ebus-options-date {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .button-container {
    padding: 8px 0;
  }
  .ebus-options-contents :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }
  .ebus-options-contents :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .error {
    color: red;
    font-size: 11px;
    margin-bottom: 0;
    margin: 4px;
  }
`;

export default style;
